import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { logout } from "../actions/auth"
import {
	getFileStatistics,
	getUserStatistics,
	StatisticsState,
	UserStatisticsData,
} from "../actions/statistics"

const initialState: StatisticsState = {
	file: {
		isLoading: false,
		data: undefined,
		error: undefined,
	},
	user: {
		isLoading: false,
		data: undefined,
		error: undefined,
	},
}

const statisticsSlice = createSlice({
	name: "statisticsSlice",
	initialState: initialState,
	reducers: {
		resetDefault: (state: StatisticsState) => {
			state.file = {
				isLoading: false,
				data: undefined,
				error: undefined,
			}
			state.user = {
				isLoading: false,
				data: undefined,
				error: undefined,
			}
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(logout.fulfilled, () => initialState)
			.addCase(getFileStatistics.pending, (state: StatisticsState) => {
				state.file = {
					...state.file,
					isLoading: true,
					error: undefined,
				}
			})
			.addCase(
				getFileStatistics.fulfilled,
				(
					state: StatisticsState,
					action: PayloadAction<FileStatisticsData[]>
				) => {
					state.file = {
						...state.file,
						isLoading: false,
						error: undefined,
						data: action.payload,
					}
				}
			)
			.addCase(getFileStatistics.rejected, (state: StatisticsState, action) => {
				state.file = {
					...state.file,
					isLoading: false,
					error: action.error.message,
				}
			})
			.addCase(getUserStatistics.pending, (state: StatisticsState) => {
				state.user = {
					//...state.user,
					isLoading: true,
					error: undefined,
				}
			})
			.addCase(
				getUserStatistics.fulfilled,
				(
					state: StatisticsState,
					action: PayloadAction<UserStatisticsData[]>
				) => {
					state.user = {
						//...state.user,
						isLoading: false,
						error: undefined,
						data: action.payload,
					}
				}
			)
			.addCase(getUserStatistics.rejected, (state: StatisticsState, action) => {
				state.user = {
					//...state.user,
					isLoading: false,
					error: action.error.message,
				}
			})
	},
})

export const { resetDefault } = statisticsSlice.actions

export default statisticsSlice.reducer
